import { api } from "@/services/api";

export const COVERAGE_STATUS = {
  COVERED: 'covered',
  NO_COVERAGE: 'no_coverage',
  UNVERIFIED: 'unverified'
};

/**
 * Resuelve en vivo qué sucursal y qué polígono cubren unas coordenadas.
 *
 * Distingue "no hay cobertura" de "no pude verificar". Son cosas distintas y
 * tratarlas igual es caro: si el servicio de polígonos falla y le decimos al
 * cliente que no hay cobertura, perdemos una venta por un problema nuestro.
 * Ante un fallo hay que dejar que el cliente siga y que el backend decida en el
 * checkout, no cerrarle la puerta ni mandarlo a otra sucursal.
 */
/**
 * ¿La sede que cubre el punto está recibiendo domicilios ahora mismo?
 *
 * `supplier_availability` responde la sede aunque esté cerrada: `find_polygon`
 * cae al primer polígono cuando ninguno tiene entrega activa, y hasta ahora la
 * devolvía sin marcarla. `active_delivery: false` es esa advertencia. Ausente
 * —servicio viejo— no dice nada, y de "no sé" no se deduce "cerrada".
 */
export const isBranchClosed = data => data?.active_delivery === false;

/**
 * La cobertura, con la forma que espera el modal de cambio de sede.
 *
 * Es la misma que traen los `candidates` del 422 del precheckout: el modal es
 * uno solo y no tiene por qué saber si lo que le llega lo resolvió el backend
 * al rechazar el pedido o el front al consultar el polígono.
 */
export const coverageCandidates = data => {
  if (!data || !data.supplier_id) return [];

  return [
    {
      supplier_id: data.supplier_id,
      supplier_label: data.supplier_label,
      polygon_id: data.polygon?.id || null,
      delivery_price: data.polygon?.delivery_price,
      minimum_order_value: data.polygon?.minimum_order_value
    }
  ];
};

export const resolveCoverage = async (latitude, longitude) => {
  if (latitude === undefined || latitude === null || longitude === undefined || longitude === null) {
    return { status: COVERAGE_STATUS.UNVERIFIED, data: null };
  };

  try {
    const response = await api.getSupplierAvailable(latitude, longitude);
    const data = response?.data;

    // Las cuentas sin full_gps responden con supplier_id y polygon en null:
    // hay cobertura, pero el cliente todavía tiene que elegir su zona.
    if (data && data.supplier_id) return { status: COVERAGE_STATUS.COVERED, data };

    return { status: COVERAGE_STATUS.NO_COVERAGE, data: null };
  } catch (error) {
    console.error(error);
    return { status: COVERAGE_STATUS.UNVERIFIED, data: null };
  };
};
